import appApi from '../../../../../api/app-api';
import { PasswordResetType } from '../../../../../api/types/auth/reset-password-type';

export const sendOtpOperation = async (
  resetType: PasswordResetType,
): Promise<string> => {
  try {
    const response = await appApi.sendPasswordResetOtp(resetType);
    return response.data.body.token;
  } catch (error) {
    console.error('Error sending OTP:', error);
    throw error;
  }
};
